import {
  DASH_LABELS,
  DASH_TYPES,
  OVRHP,
  DASH_TYPE_GROUPS,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  OVRHP: {
    label: DASH_LABELS.UPPER_PANEL_RIGHT,
    partOverride: 'M2_OVRHP',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.OVERHEAD_35M_002,
  type: DASH_TYPE_GROUPS.OVERHEAD,
  panels: [OVRHP],
  width: 1000,
  height: 200,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  C: 'Switch',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    OVRHP: {
      id: OVRHP,
      label: DASH_LABELS.UPPER_PANEL_RIGHT,
      groups: {
        OVRHP: {
          id: OVRHP,
          panel: OVRHP,
          isMsfOrMst: true,
          parent: [OVRHP],
          label: DASH_LABELS.UPPER_PANEL_RIGHT,
          detail: ['C'],
        },
      },
    },
  },
}
